import React from 'react';
import Container from '@mui/material/Container';
import Paper from '@mui/material/Paper';
import { LzTFormSizes } from '@lz-types/types';
import LzXCanvasHeading from './CanvasHeading';

export interface LzPCanvas {
    heading?: string;
    children?: React.ReactNode;
    className?: string;
    style?: React.CSSProperties;
    canvasSize?: LzTFormSizes;
    noPadding?: boolean;
}

export default function LzXCanvas(props: LzPCanvas) {
    return (
        <div className={'lz-canvas lz-form-page lz-form-page-' + (props.canvasSize ? props.canvasSize : 'full')}>
            <Paper elevation={2}>
                <Container>
                    <div style={{
                        paddingTop: props.noPadding ? 0 : 12,
                        paddingBottom: props.noPadding ? 0 : 12,
                    }}>
                        {props.heading && <LzXCanvasHeading>{props.heading}</LzXCanvasHeading>}
                        {props.children}
                    </div>
                </Container>
            </Paper>
        </div>
    );
}
